import { render, staticRenderFns } from "./NotifyContent.vue?vue&type=template&id=d632da88"
import script from "./NotifyContent.vue?vue&type=script&lang=js"
export * from "./NotifyContent.vue?vue&type=script&lang=js"
import style0 from "./NotifyContent.vue?vue&type=style&index=0&id=d632da88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/i18n/template/projects/operation/views/Dashboard/CashOutMonitor/NotifyContent.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FVolumes%2FSSD%2Fjenkins_workspace%2Fworkspace%2FJL_UAT_OPERATION%2Fsrc%2Fprojects%2Foperation%2Fviews%2FDashboard%2FCashOutMonitor%2FNotifyContent.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports